import React, { Component } from 'react';
import RUCreationLotsTableList from '../UsedRentalsCreation/UsedRentalsLots/RUCreationLotsTableList';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import DropdownListAPI from '../../../API/DropdownListAPI';
import grey from '@material-ui/core/colors/grey';
import RUManagementLotEditForm from './UsedRentalsEditLots/RUManagementLotEditForm';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import OptionalsAPI from '../../../API/OptionalsAPI';
import { handleServerError } from '../../../Utils/Helper';
import { FONT_FAMILY_TYPOGRAPHY, UR_MODULE } from '../../../Utils/Constants';


const aquaBluePalette = createMuiTheme({
  palette: {
    primary: {
      light: '#95dedd',
      main: '#00B1AF',
      dark: '#007b7a',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});


export class RUManagementContent extends Component {
  _isMounted;

  constructor(props) {
    super(props);
    this.state = {
      ruLotStateList: [],
      negotiationLot: {},
      shouldReloadList: false,
      showRULotEditForm: false,
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const dropdownListDataAPI = new DropdownListAPI();
    const optionalsDataAPI = new OptionalsAPI();

    Promise.all([dropdownListDataAPI.getAllLotStates(UR_MODULE, false), optionalsDataAPI.getAllOptionals()]).then((response) => {
      if (this._isMounted) {
        this.setState({
          ruLotStateList: response[0].data,
          optionalsData: response[1].data
        });
      }
    }).catch((negLotStateListError, optionalsListError) => {
      if (this._isMounted)
        this.setState({
          openError: true,
          alertMessage: handleServerError(negLotStateListError || optionalsListError)
        });
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  openEditRULotMainForm(oNegLot) {
    if (this._isMounted)
      this.setState({
        showRULotEditForm: !this.state.showRULotEditForm,
        negotiationLot: oNegLot
      });
  };

  reloadRUManagementLotsTableList() {
    if (this._isMounted) {
      this.setState({ shouldReloadList: true });
      this.setState({ shouldReloadList: false });
    }
  };


  render() {

    return (
      <div>
        <MuiThemeProvider theme={aquaBluePalette}>
          <RUCreationLotsTableList
            negotiationLotStateList={this.state.ruLotStateList}
            openEditRULotMainForm={this.openEditRULotMainForm.bind(this)}
            titleNegLot={this.props.titleTableListNegLot}
            titleTableList={this.props.titleTableList}
            showContent={this.props.showContent}
            shouldReloadList={this.state.shouldReloadList}
          />
          {!this.state.negotiationLot ?
            null
            :
            <RUManagementLotEditForm
              open={this.state.showRULotEditForm}
              reloadRUManagementLotsTableList={this.reloadRUManagementLotsTableList.bind(this)}
              optionalsData={this.state.optionalsData}
              openEditRULotMainForm={this.openEditRULotMainForm.bind(this)}
            />
          }
        </MuiThemeProvider>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

export default RUManagementContent


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/RUManagementContent.js